// src/get-window-frames.ts
function getWindowFrames(win) {
  const frames = {
    each(cb) {
      for (let i = 0; i < win.frames?.length; i += 1) {
        const frame = win.frames[i];
        if (frame)
          cb(frame);
      }
    },
    addEventListener(event, listener, options) {
      frames.each((frame) => {
        try {
          frame.document.addEventListener(event, listener, options);
        } catch (err) {
          console.warn(err);
        }
      });
      return () => {
        try {
          frames.removeEventListener(event, listener, options);
        } catch (err) {
          console.warn(err);
        }
      };
    },
    removeEventListener(event, listener, options) {
      frames.each((frame) => {
        try {
          frame.document.removeEventListener(event, listener, options);
        } catch (err) {
          console.warn(err);
        }
      });
    }
  };
  return frames;
}

export {
  getWindowFrames
};
